"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVisible = exports.resizeChangeHandler = void 0;

var _constants = require("../../constants");

var _utils = require("../../utils");

var resizeChangeHandler = function resizeChangeHandler(updateVisible) {
  (0, _utils.resizeChange)(function (event) {
    updateVisible(event);
  });
};

exports.resizeChangeHandler = resizeChangeHandler;

var isVisible = function isVisible(_ref) {
  var only = _ref.only;
  var visible = false;

  if (only) {
    if (!Array.isArray(only)) {
      only = [only];
    }

    visible = !isCurrentBreak(only);
  }

  return visible;
};

exports.isVisible = isVisible;

var isCurrentBreak = function isCurrentBreak(only) {
  return only.includes(getCurrentBreak());
};

var getCurrentBreak = function getCurrentBreak() {
  var width = window.innerWidth;
  var currentBreak = 'xl';

  if (width < _constants.BREAKPOINT.SM) {
    currentBreak = 'xs';
  } else if (width >= _constants.BREAKPOINT.SM && width < _constants.BREAKPOINT.MD) {
    currentBreak = 'sm';
  } else if (width >= _constants.BREAKPOINT.MD && width < _constants.BREAKPOINT.LG) {
    currentBreak = 'md';
  } else if (width >= _constants.BREAKPOINT.LG && width < _constants.BREAKPOINT.XL) {
    currentBreak = 'lg';
  }

  return currentBreak;
};